import React from "react";

import { ConfirmModal } from "@amphore-dev/amphore-lib";
import { t } from "i18next";
import { Trans } from "react-i18next";

import { TTask } from "@/types";

interface IDeleteTasksConfirmModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	items: TTask[];
}

export const DeleteTasksConfirmModal: React.FC<
	IDeleteTasksConfirmModalProps
> = ({ items = [], ...props }) => {
	return (
		<ConfirmModal
			{...props}
			title={t(
				"tasks.confirmDelete.title",
				items.length > 1
					? {
							count: items.length,
						}
					: undefined
			)}
			confirmText={t("actions.delete")}
			cancelText={t("actions.cancel")}
			confirmColor="danger"
		>
			<Trans
				i18nKey="tasks.confirmDelete.message"
				values={
					items.length > 1
						? { count: items.length }
						: {
								name: items[0]?.name,
							}
				}
				components={{ b: <b /> }}
			/>
		</ConfirmModal>
	);
};
